import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import firebase from './Firebase';
import  ReactTinyLink  from  'react-tiny-link';

class App extends Component {
  constructor(props) {
    super(props);
    this.ref = firebase.firestore().collection('boards');
    this.unsubscribe = null;
    this.state = {
      boards: []
    };
  }

  onCollectionUpdate = (querySnapshot) => {
    const boards = [];
    querySnapshot.forEach((doc) => {
      const { keyword1,keyword2,keyword3, description } = doc.data();
      boards.push({
        key: doc.id,
        doc, // DocumentSnapshot
        keyword1,
        keyword2,
        keyword3,
        description,
      });
    });
    this.setState({
      boards
   });
  }

  componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
  }

  render() {
    return (
      <div class="container">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">
              유용한 링크 공유 시스템
            </h3>
          </div>
          <div class="panel-body">
            <h4><Link to="/create">공유하기</Link></h4>
            <table class="table table-stripe">

                {this.state.boards.map(board =>
                  <tr>
                  <td> #{board.keyword1}</td>
                  <td> #{board.keyword2}</td>
                  <td> #{board.keyword3}</td>
                  <td> <ReactTinyLink cardSize="small" showGraphic={true} maxLine={2} minLine={1} url={board.description}/></td> 

                  </tr>
                )}
                
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default App;